import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { MiniPill } from '../../../ui/MiniPill/MiniPill.jsx'
import { QuickList } from '../interactions/QuickList.jsx'

/**
 * ParkingLotCard — session-parking (catalog #3, CORE).
 *
 * Quick-capture list. Each item shows a "parked" MiniPill.
 * Age computation is server-side; for Phase F we render the parked pill
 * without age — age will be wired when the row carries a `parkedAt` field.
 *
 * Phase F: singleton note row (slot="parking-lot"). The QuickList serialises
 * items as a newline-separated string inside the note text for simplicity.
 * Phase H will promote parking-lot items to typed rows with `parkedAt`.
 */

export function ParkingLotCard({ text = '', onChange, disabled = false }) {
  // Serialise the parking-lot items as a simple list inside the note text.
  // The note text holds newline-separated items.
  const items = text ? text.split('\n').filter(Boolean) : []

  function handleChange({ items: nextItems }) {
    onChange?.(nextItems.join('\n'))
  }

  return (
    <CardFrame
      kind="session"
      icon="P"
      iconClass="mustard"
      title="Parking lot"
      prompt="What should we come back to?"
      state={disabled ? 'locked' : items.length > 0 ? 'filled' : 'empty'}
      data-testid="session-card-parking-lot"
      className="session-card"
    >
      <QuickList
        items={items}
        onChange={handleChange}
        maxItems={20}
        readOnly={disabled}
        addLabel="add to parking lot"
      />
      {items.length > 0 && (
        <div className="parking-lot__pills" aria-label="Parked items">
          {items.map((_, i) => (
            <MiniPill key={i} kind="parked" aria-label="Parked">parked</MiniPill>
          ))}
        </div>
      )}
    </CardFrame>
  )
}
